<div class="outer-container" [formGroup]="formGroup">

  <mat-form-field class="form-field" [ngClass]="{'global-form-field-highlight-non-empty': _isFilter}">

    <mat-label>
      <span>
        {{ label }}
      </span>
      @if (!!infoTip?.length) {
        <lib-vitu-tooltip
          class="info-tip"
          [text]="infoTip">
          <i class="far fa-info-circle"></i>
        </lib-vitu-tooltip>
      }
    </mat-label>

    <input
      [ngClass]="{'obscured': type === 'obscured'}"
      #inputElement
      [type]="inputType"
      matInput
      [formControlName]="formFieldName"
      [formControl]="formControl"
      [readonly]="_readonly"
      [required]="hasRequiredValidator"
      [disableControl]="_disabled"
      [autocomplete]="autocomplete"
      [maxlength]="maxlength"
      [imask]="mask"
      [unmask]="unmaskInputType"
      [libTwoDigitDecimalNumber]="(type === 'twoDigitDecimal') || (type === 'twoDigitDecimalAllowNegative') || (type === 'twoDigitDecimalAllowZeroNotNegative')"
      [libTwoDigitDecimalNumberAllowNegative]="type === 'twoDigitDecimalAllowNegative'"
      [libTwoDigitDecimalNumberAllowZeroNotNegative]="type === 'twoDigitDecimalAllowZeroNotNegative'"
      (blur)="onBlur($event)"
      (change)="onChange($event)">

    @if (prefix) {
      <span matTextPrefix>{{ prefix + '&nbsp;' }}</span>
    }

    @if (showReset) {
      <button
        matSuffix mat-icon-button
        libStopPropagation
        aria-label="Clear" (click)="handleReset.emit()">
        <mat-icon>close</mat-icon>
      </button>
    }

    @if (showButton) {
      <button
        matSuffix mat-icon-button
        libStopPropagation
        (click)="handleButton.emit()">
        <mat-icon>{{ showButton }}</mat-icon>
      </button>
    }

    @for (item of errors | keyvalue; track item.key) {
      <mat-error>{{ resolveError(errors, item.key) }}</mat-error>
    }

  </mat-form-field>

  @if ((type === 'obscured') && inputElement.value) {
    <div class="toggle-show-obscured" (click)="onClickToggleShowObscured()">
      <i [class]="'far ' + (showObscured ? 'fa-eye-slash' : 'fa-eye')"></i>
    </div>
  }

</div>
